module.exports = __webpack_public_path__ + "static/media/confirmed.27a26c59.svg";